import { useMemo } from 'react';
import type { Dayjs } from 'dayjs';
import { z } from 'zod';

const dayjsSchema = z.custom<Dayjs | null>(
  (val) => val === null || val instanceof Date || typeof val === 'object',
);

export const useQualificationSchema = () => {
  const schema = useMemo(() => {
    return z.object({
      brands: z.array(z.string()).optional(),
      quitAt: dayjsSchema.nullable().optional(),
      certification: z.boolean().optional(),
    });
  }, []);

  return schema;
};

export type QualificationFormValues = z.infer<
  ReturnType<typeof useQualificationSchema>
>;
